import { ThemeCustomization } from 'pages/storebuilder/customization';

export const StoreBuilderView = () => {
  return (
    <>
      <ThemeCustomization />
    </>
  );
};
